'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _maxSafeInteger = require('babel-runtime/core-js/number/max-safe-integer');

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

var _enquire = require('enquire.js');

var _enquire2 = _interopRequireDefault(_enquire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function responsive(images, $) {
    var context = {};

    context.breakPoints = [{
        min: 0,
        max: 479,
        mediaQuery: '(max-width: 29.999em)',
        toString: function toString() {
            return 'extraNarrow';
        }
    }, {
        min: 480,
        max: 719,
        mediaQuery: '(min-width: 30em) and (max-width: 44.999em)',
        toString: function toString() {
            return 'narrow';
        }
    }, {
        min: 720,
        max: 989,
        mediaQuery: '(min-width: 45em) and (max-width: 61.874em)',
        toString: function toString() {
            return 'medium';
        }
    }, {
        min: 990,
        max: 1255,
        mediaQuery: '(min-width: 61.875em) and (max-width: 78.499em)',
        toString: function toString() {
            return 'wide';
        }
    }, {
        min: 1256,
        max: _maxSafeInteger2.default || Number.MAX_VALUE,
        mediaQuery: '(min-width: 78.5em)',
        toString: function toString() {
            return 'extraWide';
        }
    }];

    context.currentBreakPoint = null;

    context.config = {
        extraNarrow: 'br-xn',
        narrow: 'br-n',
        medium: 'br-m',
        wide: 'br-w',
        extraWide: 'br-xw'
    };

    context.BreakPointListener = function () {
        context.onBreakPointChange = function (breakPointObj) {
            if (breakPointObj !== context.currentBreakPoint) {
                $(window.document).trigger('breakPoint.changed', [breakPointObj, context.currentBreakPoint]);
                context.currentBreakPoint = breakPointObj;
            }
        };

        function tempBP(breakPointObj) {
            _enquire2.default.register(breakPointObj.mediaQuery, function () {
                context.onBreakPointChange(breakPointObj);
            });
        }

        for (var breakPointId in context.breakPoints) {
            var breakPoint = context.breakPoints[breakPointId];
            tempBP(breakPoint);
        }
    };

    /*
    * Loop through all breakpoint sized and call change image method to each item
    * @param sizes Array of all breakpoint sizes
    */
    context.changeImagesOnShowMoreClick = function (sizes) {
        context.BreakPointListener();
        var keys = (0, _keys2.default)(sizes);

        for (var key in keys) {
            var cls = keys[key];
            context.config = sizes[cls];
            context.changeSourceOfImage($(cls));
        }
    };

    /*
     * Loop through all images and call change src attribute
     * @param images Jquery selection with images
     */
    context.changeSourceOfImage = function (images) {
        $.each(images, function (key, value) {
            var image = $(images[key]);
            context.changeCallback(image, image.data(context.config[context.currentBreakPoint.toString()]));
        });
    };

    context.changeCallback = function (image, nextImg, oldImg) {
        if (image.attr('src') !== nextImg) {
            image.attr('src', nextImg);
        }
    };

    $(window.document).on('breakPoint.changed', function (event, newBreakPoint, oldBreakPoint) {
        $.each(images, function (key, value) {
            var image = $(images[key]);
            context.changeCallback(image, image.data(context.config[newBreakPoint.toString()]), oldBreakPoint ? image.data(context.config[oldBreakPoint.toString()]) : '');
        });
    });

    return context;
}

exports.default = responsive;


//////////////////
// WEBPACK FOOTER
// ./public/js/breakpointImageLoader.js
// module id = 418
// module chunks = 0